<template>
  <b-overlay :show="show" rounded="sm">
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="8">
              <h3 tabindex="0">Listar Inscrições</h3>
            </b-col>
            <!--<b-col md="4">
              <b-button @click="navigate('/participante/cadastro')" block variant="primary" v-if="can('participante.update')" >
                    <i class="fa fa-plus"></i>
                  <span>Novo Participante</span>
              </b-button>
            </b-col>-->
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group label="Nome, CPF, etc...:">
                <b-form-input type="text" id="name" v-model="filtros.filter"
                  placeholder="Nome, CPF, etc..."></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="4">
              <b-form-group label="Período - Data Início:" for="data_inicio">
                <b-form-input id="data_inicio" v-model="filtros.data_inicio" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Início" />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="4">
              <b-form-group label="Periodo - Data Fim:" for="data_final">
                <b-form-input id="data_final" v-model="filtros.data_final" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Fim" />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="4">
              <b-form-group label="Situação:">
                <b-form-select v-model="filtros.situacao" class="mb-3">
                  <option selected :value="null"> Selecione </option>
                  <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="4">
              <b-form-group label="Formulários:">
                <b-form-select v-model.trim="filtros.formulario" placeholder="" class="mb-3"
                  :options='options_formularios'>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-for="(perguntas, index) in perguntas_respostas" :key="index">
              <b-col cols="4">
                <b-form-group label="Perguntas:">
                  <b-form-select :disabled='disable_perguntas' @change="getRespostas($event, index)"
                    class="mb-3">
                    <option selected :value="null">Selecione</option>
                    <option v-for="pergunta in perguntas.options_perguntas" :key="pergunta.id" :value="pergunta.id">
                      {{ pergunta.titulo }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Respostas:">
                  <b-form-select :disabled='disable_respostas' v-model="filtros.respostas[index]"
                    class="mb-3">
                    <option selected :value="null">Selecione</option>
                    <option v-for="resposta in perguntas.options_respostas" :key="resposta.id" :value="resposta.id">
                      {{ resposta.resposta }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col> 
              <b-col sm="1">
              <b-button block style="margin-top: 46%;" variant="primary" @click="adicionarCamposPerguntas">
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>  
            <b-col v-if="index > 0 " sm="1">
              <b-button block style="margin-top: 46%;" variant="danger" @click="removerCamposPerguntas(index)">
                <i class="fa fa-minus"></i>
              </b-button>
            </b-col>  
          </b-row>   
          <b-row>
            <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
              <b-button block @click="limpar">
                <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
              </b-button>
            </b-col>
            <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>
            <b-col offset-lg="9" sm="12" md="4" lg="3">
              <b-button block variant="primary" @click="abrirModalImportarInscricoes">
                &nbsp;&nbsp;<span>Importar Inscrições</span>
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="primary" @click="abrirModalExportar">
                <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar</span>
              </b-button>
            </b-col>
          </b-row>

        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <b-col class="table-responsive">
                  <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                    class="table table-bordered table-striped table-sm">
                    <thead>
                      <tr>
                        <th tabindex="0" scope="col" style="width: 5%"><input type="checkbox" @click="selectAll"
                            v-model="allSelected"> Credenciar</th>
                        <th tabindex="0" scope="col" style="width: 5%"><input type="checkbox" @click="selectAllCertificado"
                            v-model="allSelectedCertificado"> Certificado</th>
                        <th tabindex="0" scope="col" style="width: 10%">Data de Inscrição</th>
                        <th tabindex="0" scope="col" style="width: 10%">Nome</th>
                        <th tabindex="0" scope="col" style="width: 10%">E-mail</th>
                        <th tabindex="0" scope="col" style="width: 10%">Situação</th>
                        <th tabindex="0" scope="col" style="width: 5%">Ações</th>
                      </tr>
                    </thead>

                    <tbody v-if="participantes.data !== undefined">
                      <tr class="action" v-for="participante in participantes.data" :key="participante.id_user">
                        <td>
                          <label class="form-checkbox">
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" :id="'defaultInline1' + participante.id"
                                :value="participante.id" v-model="selecionados" :disabled="participante.situacao === 'C'">
                              <label class="custom-control-label" :for="'defaultInline1' + participante.id"></label>
                            </div>
                          </label>
                        </td>
                        <td style="text-align: center;">
                          <label class="form-checkbox">
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" :id="'defaultInline2' + participante.id"
                                v-model="participantes_selecionados" :value="participante.id"
                                :disabled="participante.emitir_certificado === true">
                              <label class="custom-control-label" :for="'defaultInline2' + participante.id"></label>
                            </div>
                          </label>
                        </td>
                        <td tabindex="0">
                          {{ participante.created_at }}
                        </td>
                        <td tabindex="0">{{ participante.nome }}</td>
                        <td tabindex="0">{{ participante.email }}</td>
                        <td tabindex="0" v-if="participante.situacao === 'P'">Inscrição em Análise</td>
                        <td tabindex="0" v-if="participante.situacao === 'C'">Credenciado</td>
                        <td>
                          <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar"
                            @click="visualizarParticipante(participante.questionario_respondido_id)">
                            <i class="fa fa-search"></i>
                          </b-button>
                          <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Alterar Resposta"
                            @click="preparaModalAlterar(participante.questionario_respondido_id)">
                            <i class="fa fa-list"></i>
                          </b-button>

                          <b-button tabindex="0" v-if="participante.emitir_certificado === true"
                            class="btn btn-sm btn-secondary action" title="Gerar Certificado"
                            @click="gerarCertificado(participante.user_id)">
                            <i class="fa fa-file-pdf-o"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="action">
                        <td colspan="9" tabindex="0">Nenhum registro de usuários...</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <pagination tabindex="0" v-show="participantes.data !== undefined" :totalPorPagina="totalPorPagina"
                  :resource="resource" :filtros="filtros"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loadingCertificado" sm="12" md="6" lg="4" xl="3" style="padding-bottom: 5px;">
              <b-button block variant="primary" @click="HabilitarDesabiltarCertificado()"
                :disabled="this.participantes_selecionados.length == 0 || disable_buttons">
                <span>Habilitar Certificado</span>
              </b-button>
            </b-col>
            <b-col v-if="loadingCertificado" sm="12" md="6" lg="4" xl="3" style="padding-bottom: 5px;">
              <b-button block variant="primary" :disabled="true">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3" style="padding-bottom: 5px;">
              <b-button block :disabled="disable_buttons" variant="primary" @click="chamarModalEmailCertificado()">
                <span>Enviar Certificado por E-mail</span>
              </b-button>
            </b-col>
            <b-col v-if="!loadingCredenciado" sm="12" md="6" lg="4" xl="3" style="padding-bottom: 5px;">
              <b-button block :disabled="disable_buttons" variant="primary" @click="credenciarParticipantes()">
                <i class="fa fa-user"></i>&nbsp;&nbsp;<span>Credenciar Participantes</span>
              </b-button>
            </b-col>
            <b-col v-if="loadingCredenciado" sm="12" md="6" lg="4" xl="3" style="padding-bottom: 5px;">
              <b-button block variant="primary" :disabled="true">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3">
              <b-button block :disabled="disable_buttons" variant="secondary"
                @click="navigate('/participante/credenciados')">
                <i class="fa fa-user"></i>&nbsp;&nbsp;<span>Visualizar Credenciados</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
        <b-modal id="modalRetomada" title="Exportar" v-model="modalExportar" @ok="cancelar()" ok-only>
          <b-col cols="8">
            <b-form-group label="Selecione o formulario que deseja exportar"
              invalid-feedback='É obrigatório informar o formulário.'>
              <b-form-select placeholder="" v-model.trim="formulario" class="mb-3" :options='options_formularios'>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col offset="2" md="4" sm="4">
            <b-button block variant="success" @click="exportarIncricoes()">
              <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Exportar</span>
            </b-button>
          </b-col>
        </b-modal>
        <b-modal id="modalEmailCertificado" title="Envio Certificado por E-mail" v-model="modalEmailCertificado"
          :hide-footer="true">
          <b-col cols="12">
            <b-form-group label="Texto do E-mail: ">
              <b-form-textarea v-model="texto_email_certificado" rows="5" max-rows="12"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-card-footer class="p-12">
            <b-row>
              <b-col md="6">
              </b-col>
              <b-col md="3">
                <b-button block variant="secondary" @click="fecharModal()">
                  <span>Cancelar</span>
                </b-button>
              </b-col>
              <b-col md="3">
                <b-button block variant="primary" @click="enviarEmail()">
                  <span>Enviar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-modal>
        <b-modal id="modalImportarInscricoes" title="Importar Inscrições" v-model="modalImportarInscricoes"
          cancel-title="Cancelar" ok-title="Importar" @ok="importarInscricoes()">
          <b-row>
            <b-col cols="8">
              <b-form-group tabindex="0" label="Nome da conferência">
                <b-form-select v-model.trim="form_importacao.conferencia_relacionada_id" class="mb-3"
                  :options='conferencias'></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal id="modalPerguntas" title="Alterar Resposta" v-model="modal_perguntas" centered hide-header-close
          no-close-on-esc no-close-on-backdrop ok-title="Alterar Resposta" cancel-title="Cancelar" @ok="alterarResposta"
          @cancel="limparModal">
          <b-row>
            <b-col>
              <b-form-group tabindex="0" label="Pergunta: *" invalid-feedback="Selecionar uma pergunta">
                <b-form-select v-model="pergunta_id" :options="listaPerguntas" value-field="id" html-field="titulo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="opcoes != []">
            <b-col>
              <b-form-group tabindex="0" label="Resposta atual:">
                <b-form-select v-model="resposta_atual" :options="opcoes" disabled value-field="id"
                  html-field="resposta" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="opcoes != []">
            <b-col>
              <b-form-group tabindex="0" label="Opções de resposta da pergunta: *"
                invalid-feedback="Selecionar uma opção">
                <b-form-select v-model="alternativa_id" :options="opcoes" value-field="id" html-field="resposta" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-modal>
      </b-card>
    </span>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
    this.$store.dispatch('setListaConferenciasRelacionadas', SessionStorage.get('conferencia_atual_id'))
    this.$store.dispatch('buscarEstadosPorRegiao')
    this.loadFormularios()
  },
  data() {
    return {
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      totalPorPagina: 50,
      resource: 'participante',
      modalCredenciar: false,
      modalCertificar: false,
      modalEmailCertificado: false,
      texto_email_certificado: '',
      perguntas: [],
      modal_perguntas: false,
      participantes_selecionados: [],
      formulario: null,
      modalAlterar: false,
      modalExportar: false,
      modalImportarInscricoes: false,
      loading: false,
      loadingCertificado: false,
      loadingCredenciado: false,
      show: false,
      idEnvio: null,
      filtros: {
        uf: null,
        participacao: null,
        filter: '',
        situacao: null,
        data_inicio: null,
        data_final: null,
        formulario: null,
        perguntas: null,
        respostas: []
      },
      form_importacao: {
        conferencia_relacionada_id: null
      },
      resposta_atual: null,
      opcoes: [],
      pergunta_id: null,
      alternativa_id: null,
      selecionados: [],
      allSelected: false,
      allSelectedCertificado: false,
      options_formularios: [{ value: null, text: 'Selecione' }],
      perguntas_formulario: [],
      perguntas_respostas: [],
      disable_perguntas: true,
      disable_respostas: true,
      disable_buttons: false,
      situacoes: [
        { 'value': 'P', 'text': 'Inscrição em Análise' },
        { 'value': 'C', 'text': 'Credenciado' }
      ]
    }
  },
  computed: {
    participantes() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          let data = this.$store.state.pagination.getList

          return data
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    conferencias() {
      return this.$store.state.conferencia.conferenciasRelacionadas
    },
    participante() {
      return this.$store.state.participante.participante
    },
    estados() {
      return this.$store.state.estado.listaEstados
    },
    listaPerguntas() {
      if (this.perguntas !== undefined) {
        return this.perguntas
      } else {
        return []
      }
    }
  },
  watch: {
    'pergunta_id': function () {
      if (this.pergunta_id !== null) {
        for (var pergunta in this.listaPerguntas) {
          if (this.pergunta_id == this.perguntas[pergunta].id) {
            this.opcoes = this.perguntas[pergunta].opcoes_perguntas_dependentes
            this.resposta_atual = this.perguntas[pergunta].alternativa_id
          }
        }
      }
    },
    'filtros.formulario': function () {
      if(!this.filtros.formulario){
        this.perguntas_respostas = []
        return false
      }
      this.adicionarPerguntaResposta()
    },
  },
  methods: {
    abrirModalExportar() {
      this.modalExportar = true
    },
    abrirModalImportarInscricoes() {
      this.modalImportarInscricoes = true
    },
    loadFormularios() {
      Vue.http.get('api/formulario/listar/' + this.conferencia_id + '/' + false).then(response => {
        if (response.body.success) {
          let formularios = response.body.data.data
          for (let i = 0; i < formularios.length; i++) {
            this.options_formularios.push({ value: formularios[i].formulario_servico_id, text: formularios[i].titulo })
          }
        }
      })
    },
    adicionarPerguntaResposta() {
      if (this.filtros.formulario) {
        this.perguntas_respostas = []
        this.filtros.respostas = []
        Vue.http.get('api/formulario/buscarPerguntasRespostas/' + this.filtros.formulario).then(response => {
          if (response.body.success) {
            if (response.body.data.dados) {
              this.perguntas_respostas.push({
                options_perguntas: response.body.data.dados,
                options_respostas: [],
              })

              this.perguntas_formulario = response.body.data.dados
              this.disable_perguntas = false
            }
          }
        })
      }
    },
    adicionarCamposPerguntas() {
      this.perguntas_respostas.push({
        perguntas_selecionadas: [],
        respostas_selecionadas: [],
        options_perguntas: this.perguntas_formulario,
        options_respostas: [],
      })
    },
    removerCamposPerguntas(key) {
      this.perguntas_respostas.splice(key, 1)
    },
    getRespostas(event, index) {
      this.perguntas_respostas[index].options_respostas.splice(index, 0)
      this.perguntas_respostas[index].options_respostas = this.perguntas_respostas[index].options_perguntas[event]['opcoes_perguntas_dependentes']
      this.disable_respostas = false
    },
    pesquisar() {
      if(this.filtros.formulario !== null && this.filtros.respostas.length == 0){
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Selecione uma resposta do formulário!', 'Alerta', 5000)
          return false
      }
      console.log(this.filtros)
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    limpar() {
      this.filtros = {
        uf: null,
        participacao: null,
        filter: '',
        situacao: null,
        data_inicio: null,
        data_final: null,
        formulario: null,
        perguntas: null,
        respostas: []
      }

      this.perguntas_respostas = []
      this.pesquisar()
    },
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    credenciarParticipantes() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.post('api/participante/credenciado', { 'participantes': this.selecionados }).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error('Selecione ao menos um participante!', 'Alerta', 5000)
            this.show = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    HabilitarDesabiltarCertificado() {
      this.$bvModal.msgBoxConfirm('Deseja habilitar a emissão de certificado para o(s) inscritos(s) selecionado(s)?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.post('api/participante/habilitarEmissaoCertificado', { 'participantes': this.participantes_selecionados }).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
              this.participantes_selecionados = []
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error('Erro ao habilitar certificado!', 'Alerta', 5000)
            this.show = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    gerarCertificado(id) {
      let data = {
        id: null,
        user_id: id
      }
      this.show = true
      Vue.http.post('api/certificado/emitirCertificado', data, { responseType: 'arraybuffer' }).then(response => {
        this.show = false
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'certificado participacao.pdf'
        link.click()
      }).catch(e => {
        this.show = false
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Certificado não encontrado', 'Alerta', 5000)
      })
    },
    importarInscricoes() {
      if (this.form_importacao.conferencia_relacionada_id === null) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Selecione a conferência que deseja importar as inscrições', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.post('api/participante/importar', { 'conferencia_relacionada_id': this.form_importacao.conferencia_relacionada_id }).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error('Erro ao importar inscrições!', 'Alerta', 5000)
            this.show = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    chamarModalEmailCertificado() {
      this.modalEmailCertificado = true
      this.texto_email_certificado = ''
    },
    fecharModal() {
      this.modalEmailCertificado = false
    },
    enviarEmail() {
      if (this.texto_email_certificado === '') {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo de Texto do E-mail é obrigatorio!', 'Alerta', 5000)
        return false
      }

      let data = {
        texto_email_certificado: this.texto_email_certificado,
        conferencia_nome: SessionStorage.get('conferencia_atual_nome')
      }
      this.show = true
      this.modalEmailCertificado = false
      Vue.http.post('api/certificado/enviarCertificadoEmail', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-success' })
          miniToastr.success(response.body.msg, 'Sucesso', 5000)
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.show = false
      }).catch(e => {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Erro ao enviar certificado!', 'Alerta', 5000)
        this.show = false
      })
    },
    selectAll() {
      this.selecionados = [];
      if (!this.allSelected) {
        for (var index in this.participantes.data) {
          this.selecionados.push(this.participantes.data[index].id);
        }
      }
    },
    selectAllCertificado() {
      this.participantes_selecionados = [];
      if (!this.allSelectedCertificado) {
        for (var index in this.participantes.data) {
          this.participantes_selecionados.push(this.participantes.data[index].id);
        }
      }
    },
    alterarResposta(e) {
      e.preventDefault()

      let valid = true
      let msg = ''

      if (this.pergunta_id === null) {
        valid = false
        msg = 'Por favor selecione uma pergunta antes de alterar!'
      } else {
        if (this.alternativa_id === null) {
          valid = false
          msg = 'Por favor selecione uma opção antes de alterar!'
        } else {
          if (this.alternativa_id === this.resposta_atual) {
            valid = false
            msg = 'Por favor selecione uma opção diferente da atual!'
          }
        }
      }

      if (valid) {
        let dados = {
          questionario_respondido_id: this.idEnvio,
          pergunta_id: this.pergunta_id,
          alternativa_id: this.alternativa_id
        }
        this.show = true
        Vue.http.post('api/formulario/alterarResposta', { dados }).then(response => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { 'class': 'fa fa-success' })
            miniToastr.success(response.body.data.msg, 'Sucesso', 5000)
            this.limparModal()
            this.$nextTick(() => {
              this.$bvModal.hide('modalPerguntas')
            })
          } else {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
            this.limparModal()
          }
          this.show = false
        }).catch(e => {
          this.show = false
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Erro no servidor: ' + e, 'Alerta', 5000)
        })
      } else {
        this.show = false
        miniToastr.setIcon('alert', 'i', { 'class': 'fa fa-warning' })
        miniToastr.warn(msg, 'Aviso', 5000)
      }

    },
    limparModal() {
      this.resposta_atual = null
      this.opcoes = []
      this.pergunta_id = null
      this.alternativa_id = null
    },
    preparaModalAlterar(id) {
      this.perguntas = []
      this.modal_perguntas = false
      this.idEnvio = null

      Vue.http.get('api/formulario/perguntasRespostas/' + id).then(response => {
        if (response.body.success) {
          this.perguntas = response.body.data.dados
          this.modal_perguntas = true
          this.idEnvio = id
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
      })
    },
    excluirParticipante(id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.delete('api/participante/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error('Erro ao excluir participante!', 'Alerta', 5000)
            this.show = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    editarParticipante(id) {
      this.$router.push('/participante/editar/' + id)
    },
    exportarIncricoes() {
      if (!this.formulario) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Selecione o formulario.', 'Alerta!', 7000)
      } else {
        let respostasID = ''
        if (this.filtros.respostas.length) {
          // transform into route params
          for (let i = 0; i < this.filtros.respostas.length; i++) {
            let resposta = null
            for (let p in this.perguntas_respostas) {
              resposta = this.perguntas_respostas[p].options_respostas.find(item => item.id === this.filtros.respostas[i])

              if (resposta && resposta !== undefined) {
                break
              }
            }

            if (this.filtros.respostas[i] !== null) {
              respostasID += (`${i === 0 ? '?' : '&'}resposta[${resposta.pergunta_id}][]=${resposta.resposta}`)
            }
          }
        }

        window.location.href = process.env.ROOT_API1 + 'api/formulario/exportarResposta/' + this.formulario + respostasID
      }
    },
    visualizarParticipante(id) {
      Vue.http.get('api/formulario/visualizarResposta/' + id, {}).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(e => { })
    },
    resetForm() {
      this.motivo = ''
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}</style>



// WEBPACK FOOTER //
// src/pages/site/interna/participante/Participante.vue